import { listenToLiveDataV2Changes } from 'modules/TradesPW3/utils';
import { broker } from 'modules/TradingChart/consts';
import HoldingsStore from 'modules/TradesPW3/Holdings/store';
import FormatService from 'modules/Format/service';
import HoldingCalculations from 'modules/TradesPW3/Holdings/HoldingCalculations';
import HoldingsService from '../HoldingsService';
import HoldingTvFormatter from './HoldingTvFormatter';

class HoldingsTvService {
  static fetchFormattedHoldings = async () => {
    if (!HoldingsService.holdings.length) {
      await HoldingsService.getHoldings();
    }

    return HoldingTvFormatter
      .formatHoldingsToTvTable(HoldingsService.holdings);
  }

  static getFormattedHoldingsPnL = () => {
    const pnlSum = HoldingCalculations.getOverallPnlSum(
      HoldingsService.holdings,
    );
    return FormatService.addRupeeSign(pnlSum, true);
  }
}

export default HoldingsTvService;

listenToLiveDataV2Changes((instrumentKey) => {
  const holdingsToUpdate = HoldingsService.holdings.filter(holding =>
    HoldingsStore.getPrimaryInstrumentKey(holding) === instrumentKey,
  );

  holdingsToUpdate.forEach(holding => {
    const formattedHolding = HoldingTvFormatter.formatHoldingToTvTable(holding);

    if (broker.instance) {
      broker.instance.updateHoldings([formattedHolding]);
      broker.instance.updateHoldingsTotalPnL();
    }
  });
});
